import type { Article, FeedCategory } from '@pff-consumer/schema'
import { useMemo } from 'react'
import { filter, includes } from 'lodash'
import { useGetFeedCategoriesQuery } from '../consumer-api'

// Converts a list of slugs to a list of full Feed Category objects that can be used downstream
export const useArticleFeedCategories = (feedCategories: Article['feedCategories']): FeedCategory[] => {
  const { data } = useGetFeedCategoriesQuery()

  return useMemo<FeedCategory[]>(() => {
    return filter(data, (d) => includes(feedCategories, d?.slug))
  }, [data, feedCategories])
}
